import React, { Suspense } from "react";
import { Navigate, useRoutes } from "react-router-dom";

//landings
const index = React.lazy(() => import('../pages/landings/Index'));

//legal
const privacyVisitorApp = React.lazy(() => import('../pages/PrivacyVisitorApp'));
const privacyManagerApp = React.lazy(() => import('../pages/PrivacyManagerApp'));

const loading = () => <div className=""></div>;

type LoadingComponentProps = {
    component: React.LazyExoticComponent<() => JSX.Element>;
};

const LoadComponent = ({ component: Component }: LoadingComponentProps) => {
    return (
        <Suspense fallback={loading()}>
            <Component />
        </Suspense>
    )
};

const AllRoutes = () => {
    return useRoutes([
        {
            //root route
            path: '/',
            element: <LoadComponent component={index} />
        },
        {
            //one privacy policy per app; /privacy points at the visitor app
            path: '/privacy/visitor-app',
            element: <LoadComponent component={privacyVisitorApp} />
        },
        {
            path: '/privacy/manager-app',
            element: <LoadComponent component={privacyManagerApp} />
        },
        {
            path: '/privacy',
            element: <Navigate to="/privacy/visitor-app" replace />
        },
    ])
}

export default AllRoutes;
